// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5956) return "static/chunks/5956-04a0fa673c039849.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3567":"4cdd4ea81e0a6a6e","7759":"c635a0f8f4acf88f"}[chunkId] + ".js";
};